import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectToServiceModule } from './elements/connect-to-service/connect-to-service.module';
import { MeetingIntegrationTranslationsModule } from './translations/meeting-integration-translations.module';

@NgModule({
  imports: [CommonModule, ConnectToServiceModule, MeetingIntegrationTranslationsModule],
})
export class MeetingIntegrationsComponentModule {}
